import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useActiveLang } from "./LocaleLink";

/** Wraps each route tree (`/` and `/de`) so its language becomes active. */
export function LocaleLayout() {
  const lang = useActiveLang();
  const { i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lang);
  }, [lang, i18n]);

  return <Outlet />;
}

export default LocaleLayout;
